import { CSSProperties, FC, ReactNode } from 'react';
import { Modal as ModalAnt } from 'antd';
import { Icon } from '../Icon/index';
import ModalHeader from './Header';
import { ModalStyled } from './styles';

export interface IModal {
  id?: string;
  title?: string | ReactNode;
  children: ReactNode;
  visible?: boolean;
  footerButtons?: ReactNode;
  width?: number | string;
  wrapClassName?: string;
  className?: string;
  customClassName?: boolean;
  mask?: boolean;
  maskClosable?: boolean;
  footerActive?: boolean;
  zIndex?: number;
  style?: CSSProperties;
  newHeader?: boolean;
  showCloseIcon?: boolean;
  getContainer?: false | HTMLElement | (() => HTMLElement);
  onCancel?: () => void;
}

const Modal: FC<IModal> = ({
  title,
  children,
  visible,
  footerButtons,
  width,
  wrapClassName,
  className,
  customClassName,
  mask = true,
  maskClosable = true,
  footerActive = true,
  zIndex,
  style,
  newHeader,
  showCloseIcon = true,
  getContainer,
  onCancel,
}) => {
  return (
    <>
      <ModalStyled />
      <ModalAnt
        title={newHeader ? undefined : title}
        open={visible}
        footer={footerButtons}
        closeIcon={<Icon icon="error" size="lg" color="branco" />}
        centered
        width={width}
        wrapClassName={wrapClassName}
        className={`
          ${(title === undefined || newHeader) ? "ant-modal-hide-header" : className}
          ${!footerActive ? "ant-modal-footer-border-none" : ""}
          ${customClassName ? "custom-class-name" : ""}
        `}
        onCancel={onCancel}
        mask={mask}
        maskClosable={maskClosable}
        zIndex={zIndex}
        getContainer={getContainer}
        style={style ? style : undefined}
      >
        {newHeader && (
          <ModalHeader
            title={title as string}
            onClose={showCloseIcon ? onCancel : undefined}
          />
        )}
        {children}
      </ModalAnt>
    </>
  );
};

export default Modal;
